module.exports = __webpack_public_path__ + "img/admin3.f3ce212a.svg";